import { render, staticRenderFns } from "./viewInvoice.vue?vue&type=template&id=13544b78&scoped=true"
import script from "./viewInvoice.vue?vue&type=script&lang=ts"
export * from "./viewInvoice.vue?vue&type=script&lang=ts"
import style0 from "./viewInvoice.vue?vue&type=style&index=0&id=13544b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13544b78",
  null
  
)

export default component.exports